import { render, staticRenderFns } from "./relatorio-detalhe-operadora.vue?vue&type=template&id=5810cd18&scoped=true"
import script from "./relatorio-detalhe-operadora.vue?vue&type=script&lang=js"
export * from "./relatorio-detalhe-operadora.vue?vue&type=script&lang=js"
import style0 from "./relatorio-detalhe-operadora.vue?vue&type=style&index=0&id=5810cd18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5810cd18",
  null
  
)

export default component.exports